// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; // Import Firebase Storage

const firebaseConfig = {
  apiKey: "AIzaSyDjiH01XH2LAoJdpqAh-qhS0UqXweZJMFQ",
  authDomain: "crispy-dosa-587f0.firebaseapp.com",
  projectId: "crispy-dosa-587f0",
  storageBucket: "crispy-dosa-587f0.firebasestorage.app",
  messagingSenderId: "575134187746",
  appId: "1:575134187746:web:560c5158ebeecd60be9ebb",
  measurementId: "G-B8XCRF383N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore (for database)
const db = getFirestore(app);

// Initialize Firebase Auth (for authentication)
const auth = getAuth(app);

// Initialize Firebase Storage (for file storage)
const storage = getStorage(app); // Initialize storage

export { db, auth, storage }; // Export storage along with db and auth
